import React from 'react';
import { bonuses } from '../data/content';
import { Accent, SectionHeading } from './SectionHeading';
export function BonusesSection() {
  return <section className="w-full bg-cream-100 px-6 pb-14 pt-4 sm:pb-16" aria-labelledby="bonos-titulo" data-id="element-1" data-mp="gxge3tl8ejfm">
      <div className="mx-auto max-w-4xl" data-id="element-2" data-mp="vu7h0cu46d9z">
        <SectionHeading id="bonos-titulo" title={<>
              5 Bonos Estratégicos <Accent data-id="element-4" data-mp="14tkr97q2b5vr">Siempre Incluidos</Accent>
            </>} subtitle="Siempre incluidos, siempre gratis: implementación, clases listas, terminología, checklists y casos reales." data-id="element-3" data-mp="qt9zm2gxhn9j" />

        <ul className="mt-8 grid gap-4 sm:grid-cols-2" data-id="element-5" data-mp="zsexr7okvel6">
          {bonuses.map(({
          number,
          title,
          description,
          image
        }) => <li key={number} className="flex h-full flex-col overflow-hidden rounded-2xl border border-cream-300/70 bg-cream-50 p-4" data-id="element-6" data-mp="19lc98tv5k3aa">
              <div className="relative overflow-hidden rounded-xl" data-id="element-7" data-mp="1nhzh3ron8duz">
                <img src={image} alt={`Portada del bono ${number}: ${title}`} width={1200} height={900} loading="lazy" decoding="async" className="aspect-[4/3] w-full object-cover" data-id="element-8" data-mp="1jjrzyvq9paj9" />
                <span className="absolute left-3 top-3 rounded-md bg-ember-500 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-white" data-id="element-9" data-mp="3tr5fi0mbe3rw">
                  Bono {number}
                </span>
                <span className="absolute right-3 top-3 rounded-md bg-forest-700 px-2.5 py-1 text-[0.65rem] font-bold uppercase tracking-wider text-ember-400" data-id="element-10" data-mp="7lqkoop4p195">
                  Gratis
                </span>
              </div>
              <h3 className="mt-4 font-display text-lg font-semibold leading-snug text-forest-800" data-id="element-11" data-mp="gjkhe0qt1wwu">{title}</h3>
              <p className="mt-2 text-sm leading-relaxed text-forest-700/70" data-id="element-12" data-mp="le6se2sz5nge">{description}</p>
            </li>)}

          <li className="flex h-full flex-col items-center justify-center rounded-2xl bg-forest-700 p-8 text-center" data-id="element-13" data-mp="qd19n0ban3ye">
            <p className="font-display text-2xl font-semibold leading-snug text-cream-50" data-id="element-14" data-mp="1094l4ws1cey0">
              Valor total de bonos  <span className="text-ember-400" style={{
              fontSize: "28px"
            }} data-id="element-15" data-mp="akfp8mzwai8b">$70 USD</span>
            </p>
            <p className="mt-3 text-sm text-cream-100/75" data-id="element-16" data-mp="5np9k0s05onf">GRATIS con tu Kit.</p>
          </li>
        </ul>
      </div>
    </section>;
}